import React from 'react';
import { createRoot } from 'react-dom/client';

import ErrorCdSsoPanel from './components/Panel';
import AuthScreenLayout from '../../components/AuthScreenLayout';

import { isSupportedBrowser } from '../../common/utils';
import UnsupportedBrowsers from '../../components/UnsupportedBrowsers';

const createSsoCdErrorPanelScreen = ({ message }) => {
  const root = createRoot(document.getElementById('ssoCdErrorPanel'));
  if (isSupportedBrowser()) {
    root.render(
      <AuthScreenLayout>
        <ErrorCdSsoPanel message={message} />
      </AuthScreenLayout>
    );
  } else {
    root.render(<UnsupportedBrowsers />);
  }
};

window.createSsoCdErrorPanelScreen = createSsoCdErrorPanelScreen;
